import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a57818d")

_pushScopeId("data-v-6a57818d")
const _hoisted_1 = { class: "all-member-container text-gray-333" }
const _hoisted_2 = { class: "mb-6 font-bold font-size-24" }
const _hoisted_3 = { class: "display-condition mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-between flex-1 overflow-hidden max-h-10"
}
const _hoisted_5 = { class: "list-condition" }
const _hoisted_6 = {
  ref: "searchRequest",
  class: "flex items-center text-sm flex-wrap"
}
const _hoisted_7 = { class: "mr-4 h-8 leading-8" }
const _hoisted_8 = { class: "mr-4 background-member mt-1" }
const _hoisted_9 = { class: "text-gray-600" }
const _hoisted_10 = { class: "background-member" }
const _hoisted_11 = { class: "text-gray-600" }
const _hoisted_12 = { class: "text-gray-600" }
const _hoisted_13 = {
  class: "flex items-center",
  style: {"min-width":"max-content"}
}
const _hoisted_14 = {
  key: 0,
  class: "text-gray-500 text-sm mr-8"
}
const _hoisted_15 = { class: "mr-2 text-sm text-blue-700 hover:opacity-75" }
const _hoisted_16 = { class: "mt-3" }
const _hoisted_17 = { class: "text-lg font-bold mb-3" }
const _hoisted_18 = { class: "flex mb-4 items-center" }
const _hoisted_19 = { class: "text-base mr-6" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "flex mb-4 items-center" }
const _hoisted_22 = { class: "text-base mr-6" }
const _hoisted_23 = { class: "value-member" }
const _hoisted_24 = { class: "flex mb-4 items-center" }
const _hoisted_25 = { class: "text-base mr-6" }
const _hoisted_26 = { class: "value-member" }
const _hoisted_27 = { class: "flex items-center justify-between" }
const _hoisted_28 = { class: "ml-1" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "flex items-center justify-center" }
const _hoisted_37 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_38 = { class: "flex items-center justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_ArrowDownBlueIcon = _resolveComponent("ArrowDownBlueIcon")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_InputSearchEmployee = _resolveComponent("InputSearchEmployee")
  const _component_CloseIcon = _resolveComponent("CloseIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.returnScreen }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('stampingRecord')), 1),
    _createVNode("div", _hoisted_3, [
      (!_ctx.showSearchDetail)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('displayConditions')), 1),
                _withDirectives(_createVNode("div", _hoisted_8, [
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t('date')), 1),
                  _createTextVNode(": " + _toDisplayString(_ctx.paramsSearchMembers.date_check), 1)
                ], 512), [
                  [_vShow, _ctx.paramsSearchMembers.date_check]
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unitNames, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "mr-4 mt-1",
                    key: item
                  }, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('department')), 1),
                      _createTextVNode(" : " + _toDisplayString(item), 1)
                    ])
                  ]))
                }), 128)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paramsSearchMembers.pp_employee_ids, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "background-member mr-4 mt-1",
                    key: item
                  }, [
                    _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t('fullName')), 1),
                    _createTextVNode(" : " + _toDisplayString(_ctx.getNameEmployee(item)), 1)
                  ]))
                }), 128))
              ], 512)
            ]),
            _createVNode("div", _hoisted_13, [
              (_ctx.heightRequestSearch > 42)
                ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.t('other')), 1))
                : _createCommentVNode("", true),
              _createVNode("div", {
                class: "cursor-pointer flex items-center",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showSearchRequired && _ctx.showSearchRequired(...args)))
              }, [
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('actionEdit')), 1),
                _createVNode("span", {
                  class: _ctx.showSearchDetail ? 'arrow-active' : ''
                }, [
                  _createVNode(_component_ArrowDownBlueIcon)
                ], 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.t('displayConditions')), 1),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.t('date')), 1),
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_DatePicker, {
              modelValue: _ctx.paramsSearchMembers.date_check,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.paramsSearchMembers.date_check = $event)),
              format: "YYYY/MM/DD"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, _toDisplayString(_ctx.t('deploy')), 1),
          _createVNode("div", _hoisted_23, [
            _createVNode(_component_MultiSelect, {
              limit: 100,
              options: _ctx.unitList,
              itemValue: "unit_id",
              itemText: "unit_name",
              modelValue: _ctx.paramsSearchMembers.unit_ids,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.paramsSearchMembers.unit_ids = $event)),
              placeholder: _ctx.t('pleaseEnterTheDepartment')
            }, null, 8, ["options", "modelValue", "placeholder"])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, _toDisplayString(_ctx.t('fullName')), 1),
          _createVNode("div", _hoisted_26, [
            _createVNode(_component_InputSearchEmployee, {
              limit: 100,
              placeholder: _ctx.t('pleaseEnterYourName'),
              modelValue: _ctx.paramsSearchMembers.pp_employee_ids,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.paramsSearchMembers.pp_employee_ids = $event)),
              options: _ctx.optionListEmployee,
              reset: _ctx.resetCount
            }, null, 8, ["placeholder", "modelValue", "options", "reset"])
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode(_component_Button, {
            class: "w-28 h-12 close text-base",
            onClick: _ctx.closeSearchDetail,
            variant: "outline-primary"
          }, {
            default: _withId(() => [
              _createVNode(_component_CloseIcon, { style: {"margin-left":"-8px"} }),
              _createVNode("span", _hoisted_28, _toDisplayString(_ctx.t('closeUp')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode("div", _hoisted_29, [
            _createVNode(_component_Button, {
              class: "w-28 h-12 reset text-base",
              onClick: _ctx.resetSearchInput,
              variant: "outline-danger"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('resetMember')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              onClick: _ctx.handleSearchMembers,
              class: "w-28 h-12 text-base ml-4"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('narrowDown')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showSearchDetail]
      ])
    ]),
    _createVNode("div", _hoisted_30, [
      _createVNode(_component_Table, {
        class: "text-center",
        headers: _ctx.allMembersHeaders,
        data: _ctx.membersCheckTime
      }, {
        check_time_type: _withId(({ item }) => [
          _createVNode("div", {
            class: ["flex items-center justify-center text-base font-bold text-white item-background", [_ctx.convertStatus(item.check_time_type, item.is_remote)]]
          }, [
            (
                _ctx.convertStatus(item.check_time_type, item.is_remote) ===
                _ctx.STATUS.CHECKIN_OFFICE
              )
              ? (_openBlock(), _createBlock("span", _hoisted_31, [
                  _createTextVNode(_toDisplayString(_ctx.t('dailyAttendanceHeaders.office')), 1),
                  _hoisted_32,
                  _createTextVNode(_toDisplayString(_ctx.t('checkIn')), 1)
                ]))
              : (
                _ctx.convertStatus(item.check_time_type, item.is_remote) ===
                _ctx.STATUS.CHECKIN_REMOTE
              )
                ? (_openBlock(), _createBlock("span", _hoisted_33, [
                    _createTextVNode(_toDisplayString(_ctx.t('dailyAttendanceHeaders.teleWork')), 1),
                    _hoisted_34,
                    _createTextVNode(_toDisplayString(_ctx.t('checkIn')), 1)
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString(_ctx.stampTypeList[item.check_time_type]), 1))
          ], 2)
        ]),
        check_time: _withId(({ item }) => [
          _createVNode("div", _hoisted_36, [
            _createTextVNode(_toDisplayString(item.check_time.slice(0, 10).split('-').join('/')) + " ", 1),
            _hoisted_37,
            _createTextVNode(" " + _toDisplayString(item.check_time.slice(11, 19)), 1)
          ])
        ]),
        location: _withId(({ item }) => [
          _createVNode("div", _hoisted_38, _toDisplayString(item.location ? item.location : '-'), 1)
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ])
  ]))
})